import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Tooltip, OptimalBoundingBoxIcon } from '@frontend/components';

import { optimalBoundingBoxTool } from 'modules/common/viewer/cadViewer/data/actions';
import { getIsOptimalBoundingBoxToolActive } from 'modules/common/viewer/cadViewer/data/reducer';

import ViewerButton from '../components/ViewerButton';
import ViewerButtonTooltip from '../components/ViewerButtonTooltip';

const OptimalBoundingBoxTool = ({ isEnabled }) => {
  const isActive = useSelector(getIsOptimalBoundingBoxToolActive);
  const dispatch = useDispatch();
  const toggleOptimalBoundingBoxTool = useCallback(() => {
    dispatch(optimalBoundingBoxTool.toggle());
  }, [dispatch]);

  return isEnabled ? (
    <Tooltip
      placement="bottom"
      label={
        <ViewerButtonTooltip
          firstLine="Optimal bounding box dimensions"
          secondLine="Focused bodies"
        />
      }
    >
      <ViewerButton
        isActive={isActive}
        aria-label="Optimal bounding box dimensions"
        onClick={toggleOptimalBoundingBoxTool}
      >
        <OptimalBoundingBoxIcon boxSize={3} />
      </ViewerButton>
    </Tooltip>
  ) : null;
};
export default OptimalBoundingBoxTool;
